<div class="ziti-page-container ziti-cert-authorities-container lt-skin-page">
  <lib-list-table-header
    [title]="title"
    subtitle="Manage the certificate authorities your network trusts"
    createLabel="Create Certificate Authority"
    infoText="Certificate authorities let identities enroll and authenticate with certificates you trust."
    [tabs]="tabs"
    [showAdd]="!itemsSelected"
    [blockCreate]="headerBlockCreate"
    [blockDelete]="headerBlockDelete"
    (actionClicked)="headerActionClicked($event)"
  >
    <span header-icon class="icon-CAs" aria-hidden="true"></span>
  </lib-list-table-header>
  <ng-content select="[slot=list-page-subheader]"></ng-content>
  <lib-list-table class="lt-skin" [tableId]="tableId" [initialPageSize]="initialPageSize"
    [noItemsReadonly]="headerBlockCreate"
    [accessDenied]="headerBlockRead"
    [rowData]="rowData"
    [isLoading]="isLoading"
    [columns]="columnDefs"
    (actionRequested)="tableAction($event)"
    [startCount]="startCount"
    [endCount]="endCount"
    [totalCount]="totalCount"
    [filterApplied]="filterApplied"
    [menuItems]="svc.menuItems"
    [headerActions]="svc.tableHeaderActions"
    [noItemsImage]="'No_Clients'"
    (tableReady)="tableReady($event)"
    >
  </lib-list-table>
</div>
@if (isLoading) {
  <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
}
